<script setup lang="ts">
  import { onMounted, reactive, useTemplateRef } from 'vue'
  import StarRatingInput from '~renderer/components/StarRatingInput.vue'
  import type { IslandPublicView } from '~shared/types/island'

  const props = defineProps<{
    island?: IslandPublicView
  }>()

  const emit = defineEmits<{
    confirm: [rating: number, comment: string]
  }>()

  const rootEl = useTemplateRef<HTMLDivElement>('rootEl')
  const state = reactive({
    shake: true,
    rating: 0,
    comment: '',
  })

  onMounted(() =>
    rootEl.value?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }),
  )
</script>

<template>
  <div
    v-if="island"
    class="w-full max-w-2xl rounded-xl border border-red-400/80 bg-purple-500 p-8 text-white shadow-2xl"
    ref="rootEl"
    :class="{ shake: state.shake }"
    @animationend="state.shake = false"
  >
    <div class="flex h-full flex-col">
      <h2 class="font-display text-center text-3xl font-bold">Thank You for Visiting!</h2>

      <!-- Input Section -->
      <div class="mt-6 mb-8 flex flex-col items-center gap-4 text-center">
        <p>Please rate your experience on</p>
        <p>{{ island.name }}</p>
        <StarRatingInput v-model="state.rating" :size="10" />
        <textarea
          v-model="state.comment"
          class="h-24 w-full resize-none rounded-lg border-2 border-white/20 bg-white/5 p-4 text-white focus:border-green-400 focus:outline-none"
          placeholder="Provide a comment for your rating..."
        ></textarea>
      </div>
      <!-- Action -->
      <div class="flex justify-center">
        <button
          @click="emit('confirm', state.rating, state.comment)"
          class="cursor-pointer rounded-lg bg-green-400 px-8 py-2 font-bold text-black transition-colors hover:bg-green-500"
        >
          Confirm Rating
        </button>
      </div>
    </div>
  </div>
</template>
